// import React, { useState, useRef } from 'react';
// import { FaSearch, FaSync, FaFileExport, FaCalendar, FaChevronDown, FaChevronUp, FaRupeeSign } from 'react-icons/fa';
// import { MdClose } from 'react-icons/md';

// // ============================================
// // STYLES
// // ============================================
// const styles = {
//     container: {
//         padding: '24px',
//         maxWidth: '1600px',
//         margin: '0 auto',
//         fontFamily: 'Segoe UI, sans-serif'
//     },
//     // Dashboard Stats
//     statsGrid: {
//         display: 'grid',
//         gridTemplateColumns: 'repeat(4, 1fr)',
//         gap: '16px',
//         marginBottom: '24px'
//     },
//     statCard: {
//         background: 'white',
//         borderRadius: '12px',
//         padding: '20px 24px',
//         boxShadow: '0 2px 8px rgba(0,0,0,0.06)',
//         border: '1px solid #f0f0f0',
//         transition: 'all 0.3s ease'
//     },
//     statLabel: {
//         fontSize: '13px',
//         color: '#94a3b8',
//         fontWeight: '500',
//         marginBottom: '6px'
//     },
//     statValue: {
//         fontSize: '28px',
//         fontWeight: '700',
//         color: '#1e293b'
//     },
//     statSub: {
//         fontSize: '12px',
//         color: '#94a3b8',
//         marginTop: '4px'
//     },
//     // Header / Filters
//     filtersBar: {
//         display: 'flex',
//         alignItems: 'center',
//         gap: '12px',
//         background: 'white',
//         padding: '12px 20px',
//         borderRadius: '12px',
//         boxShadow: '0 2px 8px rgba(0,0,0,0.06)',
//         border: '1px solid #f0f0f0',
//         marginBottom: '24px',
//         flexWrap: 'wrap'
//     },
//     searchWrapper: {
//         display: 'flex',
//         alignItems: 'center',
//         flex: '1',
//         minWidth: '200px',
//         background: '#f8fafc',
//         borderRadius: '8px',
//         padding: '0 12px',
//         border: '1px solid #e2e8f0',
//         transition: 'all 0.2s ease'
//     },
//     searchInput: {
//         border: 'none',
//         background: 'transparent',
//         padding: '10px 8px',
//         fontSize: '14px',
//         outline: 'none',
//         flex: '1',
//         color: '#334155'
//     },
//     // Date Filter Button
//     dateFilterBtn: {
//         display: 'flex',
//         alignItems: 'center',
//         gap: '8px',
//         padding: '10px 16px',
//         background: '#f8fafc',
//         border: '1px solid #e2e8f0',
//         borderRadius: '8px',
//         fontSize: '14px',
//         color: '#334155',
//         cursor: 'pointer',
//         transition: 'all 0.2s ease',
//         minWidth: '140px',
//         whiteSpace: 'nowrap'
//     },
//     actionBtn: {
//         display: 'flex',
//         alignItems: 'center',
//         gap: '6px',
//         padding: '10px 18px',
//         border: 'none',
//         borderRadius: '8px',
//         fontSize: '14px',
//         fontWeight: '500',
//         cursor: 'pointer',
//         transition: 'all 0.2s ease'
//     },
//     // Vendor Card
//     vendorCard: {
//         background: 'white',
//         borderRadius: '12px',
//         boxShadow: '0 2px 8px rgba(0,0,0,0.06)',
//         border: '1px solid #f0f0f0',
//         marginBottom: '12px',
//         overflow: 'hidden',
//         transition: 'all 0.3s ease'
//     },
//     vendorHeader: {
//         display: 'flex',
//         alignItems: 'center',
//         justifyContent: 'space-between',
//         padding: '16px 24px',
//         cursor: 'pointer',
//         transition: 'all 0.2s ease',
//         borderBottom: '1px solid transparent'
//     },
//     vendorInfo: {
//         display: 'flex',
//         alignItems: 'center',
//         gap: '16px'
//     },
//     vendorName: {
//         fontSize: '16px',
//         fontWeight: '600',
//         color: '#1e293b'
//     },
//     vendorId: {
//         fontSize: '13px',
//         color: '#94a3b8'
//     },
//     vendorTotal: {
//         fontSize: '18px',
//         fontWeight: '700',
//         color: '#e66d33'
//     },
//     // Expanded Content
//     expandedContent: {
//         padding: '0 24px 24px 24px',
//         background: '#fafbfc',
//         borderTop: '1px solid #f0f0f0'
//     },
//     historyTable: {
//         width: '100%',
//         borderCollapse: 'collapse',
//         marginTop: '16px',
//         fontSize: '14px'
//     },
//     th: {
//         textAlign: 'left',
//         padding: '12px 16px',
//         background: '#f1f5f9',
//         color: '#475569',
//         fontWeight: '600',
//         borderBottom: '2px solid #e2e8f0'
//     },
//     td: {
//         padding: '12px 16px',
//         borderBottom: '1px solid #e8ecf0',
//         color: '#334155'
//     },
//     // Modal
//     modalOverlay: {
//         position: 'fixed',
//         top: 0,
//         left: 0,
//         right: 0,
//         bottom: 0,
//         background: 'rgba(0,0,0,0.5)',
//         backdropFilter: 'blur(4px)',
//         display: 'flex',
//         alignItems: 'center',
//         justifyContent: 'center',
//         zIndex: 1000,
//         padding: '20px'
//     },
//     modalContent: {
//         background: 'white',
//         borderRadius: '16px',
//         padding: '32px',
//         maxWidth: '480px',
//         width: '100%',
//         boxShadow: '0 20px 60px rgba(0,0,0,0.3)'
//     },
//     modalHeader: {
//         display: 'flex',
//         justifyContent: 'space-between',
//         alignItems: 'center',
//         marginBottom: '24px'
//     },
//     modalTitle: {
//         fontSize: '20px',
//         fontWeight: '700',
//         color: '#1e293b'
//     },
//     modalClose: {
//         background: 'none',
//         border: 'none',
//         fontSize: '24px',
//         cursor: 'pointer',
//         color: '#94a3b8',
//         padding: '4px'
//     },
//     modalBody: {
//         display: 'flex',
//         flexDirection: 'column',
//         gap: '16px'
//     },
//     dateInputGroup: {
//         display: 'flex',
//         flexDirection: 'column',
//         gap: '6px'
//     },
//     dateLabel: {
//         fontSize: '13px',
//         fontWeight: '500',
//         color: '#475569'
//     },
//     dateInput: {
//         padding: '10px 14px',
//         border: '1px solid #e2e8f0',
//         borderRadius: '8px',
//         fontSize: '14px',
//         outline: 'none',
//         transition: 'all 0.2s ease',
//         color: '#334155'
//     },
//     applyBtn: {
//         padding: '12px',
//         background: '#e66d33',
//         color: 'white',
//         border: 'none',
//         borderRadius: '8px',
//         fontSize: '16px',
//         fontWeight: '600',
//         cursor: 'pointer',
//         transition: 'all 0.2s ease',
//         marginTop: '8px'
//     },
//     // Dropdown
//     dropdown: {
//         position: 'absolute',
//         top: 'calc(100% + 4px)',
//         left: 0,
//         background: 'white',
//         border: '1px solid #e2e8f0',
//         borderRadius: '12px',
//         boxShadow: '0 10px 30px rgba(0,0,0,0.15)',
//         minWidth: '160px',
//         overflow: 'hidden',
//         zIndex: 100
//     },
//     dropdownItem: {
//         padding: '10px 18px',
//         fontSize: '14px',
//         cursor: 'pointer',
//         transition: 'all 0.15s ease',
//         color: '#334155'
//     },
//     emptyState: {
//         textAlign: 'center',
//         padding: '40px 20px',
//         color: '#94a3b8'
//     },
//     creditPositive: {
//         color: '#16a34a',
//         fontWeight: '600'
//     },
//     creditNegative: {
//         color: '#dc2626',
//         fontWeight: '600'
//     }
// };

// // ============================================
// // DUMMY DATA
// // ============================================
// const dummyVendors = [
//     {
//         id: 'VEN-001',
//         name: 'Maamaas Houses - Hyderabad',
//         totalCredited: 12500,
//         history: [
//             { id: 'pay_TK03YqP1hIaIHt', amount: 5000, date: '2026-07-31', time: '11:18 AM' },
//             { id: 'pay_TB27Q8pS4oIwU', amount: 4000, date: '2026-07-08', time: '07:28 PM' },
//             { id: 'pay_T9HwRLWytmztDU', amount: 2000, date: '2026-07-04', time: '09:39 AM' },
//             { id: 'pay_T8BprzoN8iDSWB', amount: 1500, date: '2026-07-01', time: '03:02 PM' }
//         ]
//     },
//     {
//         id: 'VEN-002',
//         name: 'Spice Garden - Bangalore',
//         totalCredited: 8750,
//         history: [
//             { id: 'pay_X9K03YqP1hIaIHt', amount: 3000, date: '2026-07-28', time: '02:15 PM' },
//             { id: 'pay_X9B27Q8pS4oIwU', amount: 2500, date: '2026-07-15', time: '11:45 AM' },
//             { id: 'pay_X9HwRLWytmztDU', amount: 3250, date: '2026-07-02', time: '06:20 PM' }
//         ]
//     },
//     {
//         id: 'VEN-003',
//         name: 'Taste of Punjab - Delhi',
//         totalCredited: 6200,
//         history: [
//             { id: 'pay_Y8K03YqP1hIaIHt', amount: 1500, date: '2026-07-25', time: '09:30 AM' },
//             { id: 'pay_Y8B27Q8pS4oIwU', amount: 2200, date: '2026-07-18', time: '04:15 PM' },
//             { id: 'pay_Y8HwRLWytmztDU', amount: 1500, date: '2026-07-10', time: '01:50 PM' },
//             { id: 'pay_Y8BprzoN8iDSWB', amount: 1000, date: '2026-07-03', time: '08:20 AM' }
//         ]
//     },
//     {
//         id: 'VEN-004',
//         name: 'Coastal Delights - Chennai',
//         totalCredited: 4300,
//         history: [
//             { id: 'pay_Z7K03YqP1hIaIHt', amount: 1800, date: '2026-07-20', time: '03:00 PM' },
//             { id: 'pay_Z7B27Q8pS4oIwU', amount: 2500, date: '2026-07-12', time: '12:30 PM' }
//         ]
//     },
//     {
//         id: 'VEN-005',
//         name: 'Mumbai Mirch - Mumbai',
//         totalCredited: 9800,
//         history: [
//             { id: 'pay_W6K03YqP1hIaIHt', amount: 3500, date: '2026-07-29', time: '10:45 AM' },
//             { id: 'pay_W6B27Q8pS4oIwU', amount: 2800, date: '2026-07-22', time: '05:30 PM' },
//             { id: 'pay_W6HwRLWytmztDU', amount: 2000, date: '2026-07-14', time: '02:00 PM' },
//             { id: 'pay_W6BprzoN8iDSWB', amount: 1500, date: '2026-07-05', time: '11:15 AM' }
//         ]
//     }
// ];

// // ============================================
// // COMPONENT
// // ============================================
// const CreditsSettlements = () => {
//     const [vendors, setVendors] = useState(dummyVendors);
//     const [expandedVendor, setExpandedVendor] = useState(null);
//     const [searchQuery, setSearchQuery] = useState('');
//     const [dateFilter, setDateFilter] = useState('All');
//     const [showDateDropdown, setShowDateDropdown] = useState(false);
//     const [showCustomDateModal, setShowCustomDateModal] = useState(false);
//     const [fromDate, setFromDate] = useState('');
//     const [toDate, setToDate] = useState('');
//     const dateDropdownRef = useRef(null);

//     // Date filter options
//     const dateOptions = ['All', 'Today', 'Yesterday', 'This Week', 'This Month', 'Custom Range'];

//     // ─── Filter Vendors ──────────────────────────────────────────
//     const filteredVendors = vendors.filter(vendor => {
//         // Search filter
//         const searchMatch = vendor.id.toLowerCase().includes(searchQuery.toLowerCase()) ||
//                            vendor.name.toLowerCase().includes(searchQuery.toLowerCase());

//         // Date filter
//         let dateMatch = true;
//         if (dateFilter !== 'All' && dateFilter !== 'Custom Range') {
//             const today = new Date();
//             const vendorDate = new Date(vendor.history[0]?.date || today);

//             switch (dateFilter) {
//                 case 'Today':
//                     dateMatch = vendorDate.toDateString() === today.toDateString();
//                     break;
//                 case 'Yesterday':
//                     const yesterday = new Date(today);
//                     yesterday.setDate(yesterday.getDate() - 1);
//                     dateMatch = vendorDate.toDateString() === yesterday.toDateString();
//                     break;
//                 case 'This Week':
//                     const weekStart = new Date(today);
//                     weekStart.setDate(today.getDate() - today.getDay());
//                     dateMatch = vendorDate >= weekStart;
//                     break;
//                 case 'This Month':
//                     dateMatch = vendorDate.getMonth() === today.getMonth() && 
//                                vendorDate.getFullYear() === today.getFullYear();
//                     break;
//                 default:
//                     dateMatch = true;
//             }
//         } else if (dateFilter === 'Custom Range' && fromDate && toDate) {
//             const from = new Date(fromDate);
//             const to = new Date(toDate);
//             const vendorDate = new Date(vendor.history[0]?.date || new Date());
//             dateMatch = vendorDate >= from && vendorDate <= to;
//         }

//         return searchMatch && dateMatch;
//     });

//     // ─── Calculate Stats ─────────────────────────────────────────
//     const totalVendors = filteredVendors.length;
//     const totalAmount = filteredVendors.reduce((sum, v) => sum + v.totalCredited, 0);

//     // ─── Toggle Expand ──────────────────────────────────────────
//     const toggleExpand = (vendorId) => {
//         setExpandedVendor(expandedVendor === vendorId ? null : vendorId);
//     };

//     // ─── Handle Date Filter Select ──────────────────────────────
//     const handleDateSelect = (option) => {
//         if (option === 'Custom Range') {
//             setShowCustomDateModal(true);
//             setShowDateDropdown(false);
//         } else {
//             setDateFilter(option);
//             setShowDateDropdown(false);
//         }
//     };

//     // ─── Apply Custom Range ──────────────────────────────────────
//     const applyCustomRange = () => {
//         if (fromDate && toDate) {
//             setDateFilter('Custom Range');
//             setShowCustomDateModal(false);
//         }
//     };

//     // ─── Format Currency ─────────────────────────────────────────
//     const formatCurrency = (amount) => {
//         return new Intl.NumberFormat('en-IN', {
//             style: 'currency',
//             currency: 'INR',
//             minimumFractionDigits: 2,
//             maximumFractionDigits: 2
//         }).format(amount);
//     };

//     // ─── Get Date Filter Display Text ───────────────────────────
//     const getDateFilterDisplay = () => {
//         if (dateFilter === 'Custom Range' && fromDate && toDate) {
//             return `${fromDate} to ${toDate}`;
//         }
//         return dateFilter;
//     };

//     return (
//         <div style={styles.container}>
//             {/* ─── Dashboard Stats ────────────────────────────────── */}
//             <div style={styles.statsGrid}>
//                 <div style={styles.statCard}>
//                     <div style={styles.statLabel}>Total Vendors</div>
//                     <div style={styles.statValue}>{totalVendors}</div>
//                     <div style={styles.statSub}>Active vendors with credits</div>
//                 </div>
//                 <div style={styles.statCard}>
//                     <div style={styles.statLabel}>Total Credits</div>
//                     <div style={styles.statValue}>{formatCurrency(totalAmount)}</div>
//                     <div style={styles.statSub}>Across all vendors</div>
//                 </div>
//                 <div style={styles.statCard}>
//                     <div style={styles.statLabel}>Average Credit</div>
//                     <div style={styles.statValue}>
//                         {totalVendors > 0 ? formatCurrency(totalAmount / totalVendors) : '₹0.00'}
//                     </div>
//                     <div style={styles.statSub}>Per vendor average</div>
//                 </div>
//                 <div style={styles.statCard}>
//                     <div style={styles.statLabel}>Highest Credit</div>
//                     <div style={styles.statValue}>
//                         {vendors.length > 0 ? formatCurrency(Math.max(...vendors.map(v => v.totalCredited))) : '₹0.00'}
//                     </div>
//                     <div style={styles.statSub}>Highest credited vendor</div>
//                 </div>
//             </div>

//             {/* ─── Filters Bar ────────────────────────────────────── */}
//             <div style={styles.filtersBar}>
//                 {/* Search */}
//                 <div style={styles.searchWrapper}>
//                     <FaSearch color="#94a3b8" size={16} />
//                     <input
//                         type="text"
//                         style={styles.searchInput}
//                         placeholder="Search by Vendor ID or Name..."
//                         value={searchQuery}
//                         onChange={(e) => setSearchQuery(e.target.value)}
//                     />
//                 </div>

//                 {/* Date Filter */}
//                 <div style={{ position: 'relative' }} ref={dateDropdownRef}>
//                     <button
//                         style={styles.dateFilterBtn}
//                         onClick={() => setShowDateDropdown(!showDateDropdown)}
//                     >
//                         <FaCalendar color="#e66d33" />
//                         <span>{getDateFilterDisplay()}</span>
//                         <FaChevronDown size={12} color="#94a3b8" />
//                     </button>

//                     {showDateDropdown && (
//                         <div style={styles.dropdown}>
//                             {dateOptions.map(option => (
//                                 <div
//                                     key={option}
//                                     style={{
//                                         ...styles.dropdownItem,
//                                         background: dateFilter === option ? '#fef3e8' : 'white',
//                                         color: dateFilter === option ? '#e66d33' : '#334155'
//                                     }}
//                                     onClick={() => handleDateSelect(option)}
//                                     onMouseEnter={(e) => e.target.style.background = '#f8fafc'}
//                                     onMouseLeave={(e) => {
//                                         if (dateFilter !== option) {
//                                             e.target.style.background = 'white';
//                                         }
//                                     }}
//                                 >
//                                     {option}
//                                 </div>
//                             ))}
//                         </div>
//                     )}
//                 </div>

//                 {/* Action Buttons */}
//                 <button
//                     style={{
//                         ...styles.actionBtn,
//                         background: '#f1f5f9',
//                         color: '#475569'
//                     }}
//                     onClick={() => {
//                         setSearchQuery('');
//                         setDateFilter('All');
//                         setFromDate('');
//                         setToDate('');
//                     }}
//                 >
//                     <FaSync size={14} /> Clear
//                 </button>

//                 <button
//                     style={{
//                         ...styles.actionBtn,
//                         background: '#e66d33',
//                         color: 'white'
//                     }}
//                     onClick={() => alert('Exporting data...')}
//                 >
//                     <FaFileExport size={14} /> Export
//                 </button>
//             </div>

//             {/* ─── Vendor List ────────────────────────────────────── */}
//             {filteredVendors.length === 0 ? (
//                 <div style={styles.emptyState}>
//                     <p>No vendors found matching the current filters.</p>
//                 </div>
//             ) : (
//                 filteredVendors.map((vendor) => (
//                     <div key={vendor.id} style={styles.vendorCard}>
//                         {/* Vendor Header */}
//                         <div
//                             style={{
//                                 ...styles.vendorHeader,
//                                 borderBottom: expandedVendor === vendor.id ? '1px solid #f0f0f0' : '1px solid transparent',
//                                 background: expandedVendor === vendor.id ? '#fafbfc' : 'white'
//                             }}
//                             onClick={() => toggleExpand(vendor.id)}
//                         >
//                             <div style={styles.vendorInfo}>
//                                 <div>
//                                     <div style={styles.vendorName}>{vendor.name}</div>
//                                     <div style={styles.vendorId}>ID: {vendor.id}</div>
//                                 </div>
//                             </div>
//                             <div style={{ display: 'flex', alignItems: 'center', gap: '20px' }}>
//                                 <div style={{ textAlign: 'right' }}>
//                                     <div style={styles.vendorTotal}>{formatCurrency(vendor.totalCredited)}</div>
//                                     <div style={{ fontSize: '12px', color: '#94a3b8' }}>Total Credited</div>
//                                 </div>
//                                 {expandedVendor === vendor.id ? (
//                                     <FaChevronUp color="#94a3b8" />
//                                 ) : (
//                                     <FaChevronDown color="#94a3b8" />
//                                 )}
//                             </div>
//                         </div>

//                         {/* Expanded Content */}
//                         {expandedVendor === vendor.id && (
//                             <div style={styles.expandedContent}>
//                                 <div style={{
//                                     padding: '16px 0 8px 0',
//                                     fontSize: '15px',
//                                     fontWeight: '600',
//                                     color: '#1e293b'
//                                 }}>
//                                     Credit History
//                                 </div>

//                                 {vendor.history.length === 0 ? (
//                                     <div style={styles.emptyState}>
//                                         <p>No credit history available</p>
//                                     </div>
//                                 ) : (
//                                     <table style={styles.historyTable}>
//                                         <thead>
//                                             <tr>
//                                                 <th style={styles.th}>Transaction ID</th>
//                                                 <th style={styles.th}>Date</th>
//                                                 <th style={styles.th}>Time</th>
//                                                 <th style={{...styles.th, textAlign:"end"}}>Amount</th>
//                                             </tr>
//                                         </thead>
//                                         <tbody>
//                                             {vendor.history.map((entry, index) => (
//                                                 <tr key={entry.id || index}>
//                                                     <td style={styles.td}>
//                                                         <span style={{ fontSize: '12px', color: '#64748b' }}>
//                                                             {entry.id}
//                                                         </span>
//                                                     </td>
//                                                     <td style={styles.td}>
//                                                         {new Date(entry.date).toLocaleDateString('en-IN', {
//                                                             day: '2-digit',
//                                                             month: 'short',
//                                                             year: 'numeric'
//                                                         })}
//                                                     </td>
//                                                     <td style={styles.td}>{entry.time}</td>
//                                                     <td style={{ ...styles.td, textAlign: 'right' }}>
//                                                         <span style={styles.creditPositive}>
//                                                             +{formatCurrency(entry.amount)}
//                                                         </span>
//                                                     </td>
//                                                 </tr>
//                                             ))}
//                                             {/* Total Row */}
//                                             <tr style={{ background: '#f8fafc' }}>
//                                                 <td colSpan="3" style={{ ...styles.td, fontWeight: '600' }}>
//                                                     Total Credits
//                                                 </td>
//                                                 <td style={{ ...styles.td, textAlign: 'right', fontWeight: '700', color: '#e66d33' }}>
//                                                     {formatCurrency(vendor.totalCredited)}
//                                                 </td>
//                                             </tr>
//                                         </tbody>
//                                     </table>
//                                 )}
//                             </div>
//                         )}
//                     </div>
//                 ))
//             )}

//             {/* ─── Custom Range Modal ─────────────────────────────── */}
//             {showCustomDateModal && (
//                 <div style={styles.modalOverlay} onClick={() => setShowCustomDateModal(false)}>
//                     <div style={styles.modalContent} onClick={(e) => e.stopPropagation()}>
//                         <div style={styles.modalHeader}>
//                             <h3 style={styles.modalTitle}>Select Date Range</h3>
//                             <button style={styles.modalClose} onClick={() => setShowCustomDateModal(false)}>
//                                 <MdClose />
//                             </button>
//                         </div>

//                         <div style={styles.modalBody}>
//                             <div style={styles.dateInputGroup}>
//                                 <label style={styles.dateLabel}>From Date</label>
//                                 <input
//                                     type="date"
//                                     style={styles.dateInput}
//                                     value={fromDate}
//                                     onChange={(e) => setFromDate(e.target.value)}
//                                     max={toDate || undefined}
//                                 />
//                             </div>

//                             <div style={styles.dateInputGroup}>
//                                 <label style={styles.dateLabel}>To Date</label>
//                                 <input
//                                     type="date"
//                                     style={styles.dateInput}
//                                     value={toDate}
//                                     onChange={(e) => setToDate(e.target.value)}
//                                     min={fromDate || undefined}
//                                 />
//                             </div>

//                             <button
//                                 style={styles.applyBtn}
//                                 onClick={applyCustomRange}
//                                 disabled={!fromDate || !toDate}
//                             >
//                                 Apply Range
//                             </button>
//                         </div>
//                     </div>
//                 </div>
//             )}
//         </div>
//     );
// };

// export default CreditsSettlements;


import React, { useState, useEffect, useRef } from 'react';
import { FaSearch, FaSync, FaFileExport, FaCalendar, FaChevronDown, FaChevronUp, FaRupeeSign } from 'react-icons/fa';
import { MdClose } from 'react-icons/md';
import { useLoader } from '../../../../context/LoaderProvider';

// ============================================
// STYLES
// ============================================
const styles = {
    container: {
        padding: "10px 0px",
        margin: '0 auto',
        fontFamily: 'Segoe UI, sans-serif'
    },
    statsGrid: {
        display: 'grid',
        gridTemplateColumns: 'repeat(4, 1fr)',
        gap: '16px',
        marginBottom: '10px'
    },
    statCard: {
        background: 'white',
        borderRadius: '12px',
        padding: '15px',
        boxShadow: '0 2px 8px rgba(0,0,0,0.06)',
        border: '1px solid #f0f0f0',
        transition: 'all 0.3s ease'
    },
    statLabel: {
        fontSize: '13px',
        color: '#94a3b8',
        fontWeight: '500',
        marginBottom: '6px'
    },
    statValue: {
        fontSize: '28px',
        fontWeight: '700',
        color: '#1e293b'
    },
    statSub: {
        fontSize: '12px',
        color: '#94a3b8',
        marginTop: '4px'
    },
    filtersBar: {
        display: 'flex',
        alignItems: 'center',
        gap: '12px',

        borderRadius: '12px',

        marginBottom: '10px',
        flexWrap: 'wrap'
    },
    searchWrapper: {
        display: 'flex',
        alignItems: 'center',
        flex: '1',
        minWidth: '200px',
        background: '#f8fafc',
        borderRadius: '8px',
        padding: '0 12px',
        border: '1px solid #e2e8f0',
        transition: 'all 0.2s ease'
    },
    searchInput: {
        border: 'none',
        background: 'transparent',
        padding: '10px 8px',
        fontSize: '14px',
        outline: 'none',
        flex: '1',
        color: '#334155'
    },
    dateFilterBtn: {
        display: 'flex',
        alignItems: 'center',
        gap: '8px',
        padding: '10px 16px',
        background: '#f8fafc',
        border: '1px solid #e2e8f0',
        borderRadius: '8px',
        fontSize: '14px',
        color: '#334155',
        cursor: 'pointer',
        transition: 'all 0.2s ease',
        minWidth: '140px',
        whiteSpace: 'nowrap'
    },
    actionBtn: {
        display: 'flex',
        alignItems: 'center',
        gap: '6px',
        padding: '10px 18px',
        border: 'none',
        borderRadius: '8px',
        fontSize: '14px',
        fontWeight: '500',
        cursor: 'pointer',
        transition: 'all 0.2s ease'
    },
    vendorCard: {
        background: 'white',
        borderRadius: '12px',
        boxShadow: '0 2px 8px rgba(0,0,0,0.06)',
        border: '1px solid #f0f0f0',
        marginBottom: '12px',
        overflow: 'hidden',
        transition: 'all 0.3s ease'
    },
    vendorHeader: {
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'space-between',
        padding: '16px 24px',
        cursor: 'pointer',
        transition: 'all 0.2s ease',
        borderBottom: '1px solid transparent'
    },
    vendorInfo: {
        display: 'flex',
        alignItems: 'center',
        gap: '16px'
    },
    vendorName: {
        fontSize: '16px',
        fontWeight: '600',
        color: '#1e293b'
    },
    vendorId: {
        fontSize: '13px',
        color: '#94a3b8'
    },
    vendorTotal: {
        fontSize: '18px',
        fontWeight: '700',
        color: '#e66d33'
    },
    expandedContent: {
        padding: '0 24px 24px 24px',
        background: '#fafbfc',
        borderTop: '1px solid #f0f0f0'
    },
    historyTable: {
        width: '100%',
        borderCollapse: 'collapse',
        marginTop: '16px',
        fontSize: '14px'
    },
    th: {
        textAlign: 'left',
        padding: '12px 16px',
        background: '#f1f5f9',
        color: '#475569',
        fontWeight: '600',
        borderBottom: '2px solid #e2e8f0'
    },
    td: {
        padding: '12px 16px',
        borderBottom: '1px solid #e8ecf0',
        color: '#334155'
    },
    modalOverlay: {
        position: 'fixed',
        top: 0,
        left: 0,
        right: 0,
        bottom: 0,
        background: 'rgba(0,0,0,0.5)',
        backdropFilter: 'blur(4px)',
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'center',
        zIndex: 1000,
        padding: '20px'
    },
    modalContent: {
        background: 'white',
        borderRadius: '16px',
        padding: '32px',
        maxWidth: '480px',
        width: '100%',
        boxShadow: '0 20px 60px rgba(0,0,0,0.3)'
    },
    modalHeader: {
        display: 'flex',
        justifyContent: 'space-between',
        alignItems: 'center',
        marginBottom: '24px'
    },
    modalTitle: {
        fontSize: '20px',
        fontWeight: '700',
        color: '#1e293b'
    },
    modalClose: {
        background: 'none',
        border: 'none',
        fontSize: '24px',
        cursor: 'pointer',
        color: '#94a3b8',
        padding: '4px'
    },
    modalBody: {
        display: 'flex',
        flexDirection: 'column',
        gap: '16px'
    },
    dateInputGroup: {
        display: 'flex',
        flexDirection: 'column',
        gap: '6px'
    },
    dateLabel: {
        fontSize: '13px',
        fontWeight: '500',
        color: '#475569'
    },
    dateInput: {
        padding: '10px 14px',
        border: '1px solid #e2e8f0',
        borderRadius: '8px',
        fontSize: '14px',
        outline: 'none',
        transition: 'all 0.2s ease',
        color: '#334155'
    },
    applyBtn: {
        padding: '12px',
        background: '#e66d33',
        color: 'white',
        border: 'none',
        borderRadius: '8px',
        fontSize: '16px',
        fontWeight: '600',
        cursor: 'pointer',
        transition: 'all 0.2s ease',
        marginTop: '8px'
    },
    dropdown: {
        position: 'absolute',
        top: 'calc(100% + 4px)',
        left: 0,
        background: 'white',
        border: '1px solid #e2e8f0',
        borderRadius: '12px',
        boxShadow: '0 10px 30px rgba(0,0,0,0.15)',
        minWidth: '160px',
        overflow: 'hidden',
        zIndex: 100
    },
    dropdownItem: {
        padding: '10px 18px',
        fontSize: '14px',
        cursor: 'pointer',
        transition: 'all 0.15s ease',
        color: '#334155'
    },
    emptyState: {
        textAlign: 'center',
        padding: '40px 20px',
        color: '#94a3b8'
    },
    creditPositive: {
        color: '#16a34a',
        fontWeight: '600'
    },
    creditNegative: {
        color: '#dc2626',
        fontWeight: '600'
    },
    loadingOverlay: {
        textAlign: 'center',
        padding: '40px 20px',
        color: '#64748b'
    }
};

// ============================================
// API URL
// ============================================
const API_URL = "https://backend.maamaas.com/food/api/vendor/credit/transaction/all";

// ============================================
// COMPONENT
// ============================================
const CreditsSettlements = () => {
    const { showLoader, hideLoader } = useLoader();
    const [vendors, setVendors] = useState([]);
    const [filteredVendors, setFilteredVendors] = useState([]);
    const [expandedVendor, setExpandedVendor] = useState(null);
    const [searchQuery, setSearchQuery] = useState('');
    const [dateFilter, setDateFilter] = useState('All');
    const [showDateDropdown, setShowDateDropdown] = useState(false);
    const [showCustomDateModal, setShowCustomDateModal] = useState(false);
    const [fromDate, setFromDate] = useState('');
    const [toDate, setToDate] = useState('');
    const [loading, setLoading] = useState(true);
    const [error, setError] = useState(null);
    const dateDropdownRef = useRef(null);

    // Date filter options
    const dateOptions = ['All', 'Today', 'Yesterday', 'This Week', 'This Month', 'Custom Range'];

    // ─── Fetch Credit Transactions ──────────────────────────────────
    const fetchCreditTransactions = async () => {
        try {
            setLoading(true);
            setError(null);
            showLoader();

            const token = localStorage.getItem("authToken");
            if (!token) {
                throw new Error("Authentication token not found");
            }

            // Get current date for default range
            const today = new Date();
            const startDate = '2026-01-01'; // Default start
            const endDate = today.toISOString().split('T')[0]; // Today

            const url = `${API_URL}/${startDate}/${endDate}`;

            const response = await fetch(url, {
                method: 'GET',
                headers: {
                    'Authorization': `Bearer ${token}`,
                    'Content-Type': 'application/json'
                }
            });

            if (!response.ok) {
                throw new Error(`Failed to fetch transactions: ${response.status}`);
            }

            const data = await response.json();

            // Group transactions by vendorId
            const vendorMap = new Map();

            data.forEach(transaction => {
                const vendorId = transaction.vendorId;

                if (!vendorMap.has(vendorId)) {
                    vendorMap.set(vendorId, {
                        id: `VEN-${String(vendorId).padStart(3, '0')}`,
                        vendorId: vendorId,
                        name: transaction.vendorRestaurentName,
                        totalCredited: 0,
                        history: []
                    });
                }

                const vendor = vendorMap.get(vendorId);
                vendor.totalCredited += transaction.creditAmount || 0;

                vendor.history.push({
                    id: transaction.transactionId || `TXN-${transaction.id}`,
                    amount: transaction.creditAmount || 0,
                    date: transaction.transactionDate ? transaction.transactionDate.split('T')[0] : '',
                    time: transaction.transactionDate ? new Date(transaction.transactionDate).toLocaleTimeString('en-US', {
                        hour: '2-digit',
                        minute: '2-digit',
                        hour12: true
                    }) : '',
                    description: transaction.description || '',
                    transactionType: transaction.transactionType || 'CREDIT',
                    transactionId: transaction.transactionId || '',
                    rawDate: transaction.transactionDate
                });
            });

            const vendorList = Array.from(vendorMap.values());

            // Sort vendors by totalCredited (highest first)
            vendorList.sort((a, b) => b.totalCredited - a.totalCredited);

            setVendors(vendorList);
            setFilteredVendors(vendorList);

        } catch (error) {
            console.error('❌ Error fetching credit transactions:', error);
            setError(error.message || 'Failed to load credit transactions');
            setVendors([]);
            setFilteredVendors([]);
        } finally {
            setLoading(false);
            hideLoader();
        }
    };

    // ─── Initial Fetch ──────────────────────────────────────────────
    useEffect(() => {
        fetchCreditTransactions();
    }, []);

    // ─── Filter Vendors ──────────────────────────────────────────
    useEffect(() => {
        let filtered = [...vendors];

        // Search filter
        if (searchQuery.trim()) {
            const query = searchQuery.toLowerCase().trim();
            filtered = filtered.filter(vendor =>
                vendor.id.toLowerCase().includes(query) ||
                vendor.name.toLowerCase().includes(query) ||
                vendor.vendorId.toString().includes(query)
            );
        }

        // Date filter
        let dateMatch = true;
        if (dateFilter !== 'All' && dateFilter !== 'Custom Range') {
            const today = new Date();

            filtered = filtered.filter(vendor => {
                if (vendor.history.length === 0) return false;

                // Check if any transaction matches the date filter
                return vendor.history.some(entry => {
                    const entryDate = new Date(entry.date);

                    switch (dateFilter) {
                        case 'Today':
                            return entryDate.toDateString() === today.toDateString();
                        case 'Yesterday':
                            const yesterday = new Date(today);
                            yesterday.setDate(yesterday.getDate() - 1);
                            return entryDate.toDateString() === yesterday.toDateString();
                        case 'This Week':
                            const weekStart = new Date(today);
                            weekStart.setDate(today.getDate() - today.getDay());
                            return entryDate >= weekStart;
                        case 'This Month':
                            return entryDate.getMonth() === today.getMonth() &&
                                entryDate.getFullYear() === today.getFullYear();
                        default:
                            return true;
                    }
                });
            });
        } else if (dateFilter === 'Custom Range' && fromDate && toDate) {
            const from = new Date(fromDate);
            const to = new Date(toDate);
            from.setHours(0, 0, 0, 0);
            to.setHours(23, 59, 59, 999);

            filtered = filtered.filter(vendor => {
                return vendor.history.some(entry => {
                    const entryDate = new Date(entry.date);
                    return entryDate >= from && entryDate <= to;
                });
            });
        }

        setFilteredVendors(filtered);
    }, [searchQuery, dateFilter, fromDate, toDate, vendors]);

    // ─── Calculate Stats ─────────────────────────────────────────
    const totalVendors = filteredVendors.length;
    const totalAmount = filteredVendors.reduce((sum, v) => sum + v.totalCredited, 0);
    const avgAmount = totalVendors > 0 ? totalAmount / totalVendors : 0;
    const maxAmount = vendors.length > 0 ? Math.max(...vendors.map(v => v.totalCredited)) : 0;

    // ─── Toggle Expand ──────────────────────────────────────────
    const toggleExpand = (vendorId) => {
        setExpandedVendor(expandedVendor === vendorId ? null : vendorId);
    };

    // ─── Handle Date Filter Select ──────────────────────────────
    const handleDateSelect = (option) => {
        if (option === 'Custom Range') {
            setShowCustomDateModal(true);
            setShowDateDropdown(false);
        } else {
            setDateFilter(option);
            setShowDateDropdown(false);
        }
    };

    // ─── Apply Custom Range ──────────────────────────────────────
    const applyCustomRange = () => {
        if (fromDate && toDate) {
            setDateFilter('Custom Range');
            setShowCustomDateModal(false);
        }
    };

    // ─── Format Currency ─────────────────────────────────────────
    const formatCurrency = (amount) => {
        return new Intl.NumberFormat('en-IN', {
            style: 'currency',
            currency: 'INR',
            minimumFractionDigits: 2,
            maximumFractionDigits: 2
        }).format(amount || 0);
    };

    // ─── Get Date Filter Display Text ───────────────────────────
    const getDateFilterDisplay = () => {
        if (dateFilter === 'Custom Range' && fromDate && toDate) {
            return `${fromDate} to ${toDate}`;
        }
        return dateFilter;
    };

    // ─── Format Date ─────────────────────────────────────────────
    const formatDate = (dateString) => {
        if (!dateString) return 'N/A';
        return new Date(dateString).toLocaleDateString('en-IN', {
            day: '2-digit',
            month: 'short',
            year: 'numeric'
        });
    };

    // ─── Format Time ─────────────────────────────────────────────
    const formatTime = (dateString) => {
        if (!dateString) return 'N/A';
        return new Date(dateString).toLocaleTimeString('en-US', {
            hour: '2-digit',
            minute: '2-digit',
            hour12: true
        });
    };

    // ─── Handle Export ────────────────────────────────────────────
    const handleExport = () => {
        if (filteredVendors.length === 0) {
            alert('No data to export.');
            return;
        }

        try {
            const csvRows = [];
            const headers = ['Vendor ID', 'Vendor Name', 'Transaction ID', 'Amount', 'Date', 'Time', 'Description', 'Type'];
            csvRows.push(headers.join(','));

            filteredVendors.forEach(vendor => {
                vendor.history.forEach(entry => {
                    const row = [
                        vendor.vendorId,
                        `"${vendor.name}"`,
                        `"${entry.transactionId || entry.id}"`,
                        entry.amount,
                        formatDate(entry.date),
                        entry.time,
                        `"${entry.description || ''}"`,
                        entry.transactionType || 'CREDIT'
                    ];
                    csvRows.push(row.join(','));
                });
            });

            const csvString = csvRows.join('\n');
            const blob = new Blob([csvString], { type: 'text/csv;charset=utf-8;' });
            const url = URL.createObjectURL(blob);
            const link = document.createElement('a');
            link.setAttribute('href', url);
            link.setAttribute('download', `credit_transactions_${new Date().toISOString().split('T')[0]}.csv`);
            document.body.appendChild(link);
            link.click();
            document.body.removeChild(link);
            URL.revokeObjectURL(url);

            alert('✅ Export successful!');
        } catch (error) {
            console.error('Export error:', error);
            alert('Failed to export data.');
        }
    };

    // ─── Handle Refresh ───────────────────────────────────────────
    const handleRefresh = () => {
        fetchCreditTransactions();
    };

    // ─── Render ───────────────────────────────────────────────────
    if (loading) {
        return (
            <div style={styles.container}>
                <div style={styles.loadingOverlay}>
                    <div className="spinner" style={{
                        width: '40px',
                        height: '40px',
                        border: '4px solid #f3f4f6',
                        borderTop: '4px solid #e66d33',
                        borderRadius: '50%',
                        animation: 'spin 1s linear infinite',
                        margin: '0 auto 12px'
                    }}></div>
                    <p>Loading credit transactions...</p>
                </div>
            </div>
        );
    }

    if (error) {
        return (
            <div style={styles.container}>
                <div style={styles.emptyState}>
                    <p style={{ color: '#dc2626', fontWeight: '600' }}>⚠️ {error}</p>
                    <button
                        onClick={handleRefresh}
                        style={{
                            ...styles.actionBtn,
                            background: '#e66d33',
                            color: 'white',
                            marginTop: '12px'
                        }}
                    >
                        Try Again
                    </button>
                </div>
            </div>
        );
    }

    return (
        <div style={styles.container}>
            {/* ─── Dashboard Stats ────────────────────────────────── */}
            <div style={styles.statsGrid}>
                <div style={styles.statCard}>
                    <div style={styles.statLabel}>Total Vendors</div>
                    <div style={styles.statValue}>{totalVendors}</div>
                </div>
                <div style={styles.statCard}>
                    <div style={styles.statLabel}>Total Credits</div>
                    <div style={styles.statValue}>{formatCurrency(totalAmount)}</div>
                </div>
                <div style={styles.statCard}>
                    <div style={styles.statLabel}>Average Credit</div>
                    <div style={styles.statValue}>
                        {totalVendors > 0 ? formatCurrency(avgAmount) : '₹0.00'}
                    </div>
                </div>
                <div style={styles.statCard}>
                    <div style={styles.statLabel}>Highest Credit</div>
                    <div style={styles.statValue}>
                        {vendors.length > 0 ? formatCurrency(maxAmount) : '₹0.00'}
                    </div>
                </div>
            </div>

            {/* ─── Filters Bar ────────────────────────────────────── */}
            <div style={styles.filtersBar}>
                {/* Search */}
                <div style={styles.searchWrapper}>
                    <FaSearch color="#94a3b8" size={16} />
                    <input
                        type="text"
                        style={styles.searchInput}
                        placeholder="Search by Vendor ID or Name..."
                        value={searchQuery}
                        onChange={(e) => setSearchQuery(e.target.value)}
                    />
                </div>

                {/* Date Filter */}
                <div style={{ position: 'relative' }} ref={dateDropdownRef}>
                    <button
                        style={styles.dateFilterBtn}
                        onClick={() => setShowDateDropdown(!showDateDropdown)}
                    >
                        <FaCalendar color="#e66d33" />
                        <span>{getDateFilterDisplay()}</span>
                        <FaChevronDown size={12} color="#94a3b8" />
                    </button>

                    {showDateDropdown && (
                        <div style={styles.dropdown}>
                            {dateOptions.map(option => (
                                <div
                                    key={option}
                                    style={{
                                        ...styles.dropdownItem,
                                        background: dateFilter === option ? '#fef3e8' : 'white',
                                        color: dateFilter === option ? '#e66d33' : '#334155'
                                    }}
                                    onClick={() => handleDateSelect(option)}
                                    onMouseEnter={(e) => e.target.style.background = '#f8fafc'}
                                    onMouseLeave={(e) => {
                                        if (dateFilter !== option) {
                                            e.target.style.background = 'white';
                                        }
                                    }}
                                >
                                    {option}
                                </div>
                            ))}
                        </div>
                    )}
                </div>

                {/* Action Buttons */}
                <button
                    style={{
                        ...styles.actionBtn,
                        background: '#f1f5f9',
                        color: '#475569'
                    }}
                    onClick={() => {
                        setSearchQuery('');
                        setDateFilter('All');
                        setFromDate('');
                        setToDate('');
                    }}
                >
                    <FaSync size={14} /> Clear
                </button>

                <button
                    style={{
                        ...styles.actionBtn,
                        background: '#e66d33',
                        color: 'white'
                    }}
                    onClick={handleRefresh}
                >
                    <FaSync size={14} /> Refresh
                </button>

                <button
                    style={{
                        ...styles.actionBtn,
                        background: '#16a34a',
                        color: 'white'
                    }}
                    onClick={handleExport}
                >
                    <FaFileExport size={14} /> Export
                </button>
            </div>

            <div style={{ maxHeight: "60vh", overflow: "auto", scrollbarWidth: "thin" }}>

                {/* ─── Vendor List ────────────────────────────────────── */}
                {filteredVendors.length === 0 ? (
                    <div style={styles.emptyState}>
                        <p>No vendors found matching the current filters.</p>
                    </div>
                ) : (
                    filteredVendors.map((vendor) => (
                        <div key={vendor.id} style={styles.vendorCard}>
                            {/* Vendor Header */}
                            <div
                                style={{
                                    ...styles.vendorHeader,
                                    borderBottom: expandedVendor === vendor.id ? '1px solid #f0f0f0' : '1px solid transparent',
                                    background: expandedVendor === vendor.id ? '#fafbfc' : 'white'
                                }}
                                onClick={() => toggleExpand(vendor.id)}
                            >
                                <div style={styles.vendorInfo}>
                                    <div>
                                        <div style={styles.vendorName}>{vendor.name}</div>
                                        {/* <div style={styles.vendorId}>ID: {vendor.id}</div> */}
                                        <div style={{ fontSize: '12px', color: '#94a3b8', marginTop: '2px' }}>
                                            {vendor.history.length} transactions
                                        </div>
                                    </div>
                                </div>
                                <div style={{ display: 'flex', alignItems: 'center', gap: '20px' }}>
                                    <div style={{ textAlign: 'right' }}>
                                        <div style={styles.vendorTotal}>{formatCurrency(vendor.totalCredited)}</div>
                                        <div style={{ fontSize: '12px', color: '#94a3b8' }}>Total Credited</div>
                                    </div>
                                    {expandedVendor === vendor.id ? (
                                        <FaChevronUp color="#94a3b8" />
                                    ) : (
                                        <FaChevronDown color="#94a3b8" />
                                    )}
                                </div>
                            </div>

                            {/* Expanded Content */}
                            {expandedVendor === vendor.id && (
                                <div style={styles.expandedContent}>
                                    <div style={{
                                        padding: '16px 0 8px 0',
                                        fontSize: '15px',
                                        fontWeight: '600',
                                        color: '#1e293b',
                                        display: 'flex',
                                        alignItems: 'center',
                                        gap: '8px'
                                    }}>
                                        <FaRupeeSign size={16} color="#e66d33" />
                                        Credit History
                                        <span style={{
                                            fontSize: '13px',
                                            fontWeight: '400',
                                            color: '#94a3b8',
                                            marginLeft: '4px'
                                        }}>
                                            ({vendor.history.length} transactions)
                                        </span>
                                    </div>
                                    <div style={{ maxHeight: "300px", overflow: "auto", scrollbarWidth: "thin" }}>
                                        {vendor.history.length === 0 ? (
                                            <div style={styles.emptyState}>
                                                <p>No credit history available</p>
                                            </div>
                                        ) : (
                                            <table style={styles.historyTable}>
                                                <thead>
                                                    <tr>
                                                        <th style={styles.th}>Transaction ID</th>
                                                        <th style={styles.th}>Date</th>
                                                        <th style={styles.th}>Time</th>
                                                        <th style={styles.th}>Description</th>
                                                        <th style={{ ...styles.th, textAlign: 'right' }}>Amount</th>
                                                    </tr>
                                                </thead>
                                                <tbody>
                                                    {vendor.history.map((entry, index) => (
                                                        <tr key={entry.id || index}>
                                                            <td style={styles.td}>
                                                                <span style={{ fontSize: '12px', color: '#64748b' }}>
                                                                    {entry.transactionId || entry.id}
                                                                </span>
                                                            </td>
                                                            <td style={styles.td}>
                                                                {formatDate(entry.date)}
                                                            </td>
                                                            <td style={styles.td}>{entry.time}</td>
                                                            <td style={styles.td}>
                                                                <span style={{ fontSize: '12px', color: '#64748b' }}>
                                                                    {entry.description || '-'}
                                                                </span>
                                                            </td>
                                                            <td style={{ ...styles.td, textAlign: 'right' }}>
                                                                <span style={styles.creditPositive}>
                                                                    +{formatCurrency(entry.amount)}
                                                                </span>
                                                            </td>
                                                        </tr>
                                                    ))}
                                                    {/* Total Row */}
                                                    <tr style={{ background: '#f8fafc' }}>
                                                        <td colSpan="4" style={{ ...styles.td, fontWeight: '600' }}>
                                                            Total Credits
                                                        </td>
                                                        <td style={{ ...styles.td, textAlign: 'right', fontWeight: '700', color: '#e66d33' }}>
                                                            {formatCurrency(vendor.totalCredited)}
                                                        </td>
                                                    </tr>
                                                </tbody>
                                            </table>
                                        )}
                                    </div>
                                </div>
                            )}
                        </div>
                    ))
                )}
            </div>
            {/* ─── Custom Range Modal ─────────────────────────────── */}
            {showCustomDateModal && (
                <div style={styles.modalOverlay} onClick={() => setShowCustomDateModal(false)}>
                    <div style={styles.modalContent} onClick={(e) => e.stopPropagation()}>
                        <div style={styles.modalHeader}>
                            <h3 style={styles.modalTitle}>Select Date Range</h3>
                            <button style={styles.modalClose} onClick={() => setShowCustomDateModal(false)}>
                                <MdClose />
                            </button>
                        </div>

                        <div style={styles.modalBody}>
                            <div style={styles.dateInputGroup}>
                                <label style={styles.dateLabel}>From Date</label>
                                <input
                                    type="date"
                                    style={styles.dateInput}
                                    value={fromDate}
                                    onChange={(e) => setFromDate(e.target.value)}
                                    max={toDate || undefined}
                                />
                            </div>

                            <div style={styles.dateInputGroup}>
                                <label style={styles.dateLabel}>To Date</label>
                                <input
                                    type="date"
                                    style={styles.dateInput}
                                    value={toDate}
                                    onChange={(e) => setToDate(e.target.value)}
                                    min={fromDate || undefined}
                                />
                            </div>

                            <button
                                style={styles.applyBtn}
                                onClick={applyCustomRange}
                                disabled={!fromDate || !toDate}
                            >
                                Apply Range
                            </button>
                        </div>
                    </div>
                </div>
            )}

            {/* ─── Spinner Animation ────────────────────────────────── */}
            <style>{`
                @keyframes spin {
                    to { transform: rotate(360deg); }
                }
            `}</style>
        </div>
    );
};

export default CreditsSettlements;